import axios from 'axios'
import { i18n } from '../../../plugins/i18n'
import { castAttributesForCamelCase } from '../../../modules/string_converter'

export const companiesSnsCategory = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
    },
    readSnsCategorySuccess(state, payload) {
      state.data = castAttributesForCamelCase(payload.data.attributes)
      state.loading = false
    },
    stopLoading(state) {
      state.loading = false
    }
  },
  actions: {
    readSnsCategory({ commit, rootState }, snsCategoryId) {
      commit('prepareConnect')
      return axios
        .get('/api/companies/' + rootState.route.params.company_uuid  + '/sns/categories/' + snsCategoryId + '.json')
        .then(res => {
          commit('readSnsCategorySuccess', res.data)
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    createSnsCategory({ commit, rootState }, payload) {
      commit('prepareConnect')
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/sns/categories.json', payload)
        .then(() => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.created', { value: i18n.t('models.snsCategory.modelName') }) }, { root: true })
          return true
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          return false
        })
    },
    updateSnsCategory({ commit, rootState }, { snsCategoryId, payload }) {
      commit('prepareConnect')
      return axios
        .patch('/api/companies/' + rootState.route.params.company_uuid + '/sns/categories/' + snsCategoryId + '.json', payload)
        .then(() => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.updated', { value: i18n.t('models.snsCategory.modelName') }) }, { root: true })
          return true
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          return false
        })
    },
    deleteSnsCategory({ commit, rootState }, snsCategoryId ) {
      commit('prepareConnect')
      return axios
        .delete('/api/companies/' + rootState.route.params.company_uuid + '/sns/categories/' + snsCategoryId + '.json')
        .then(() => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.deleted', { value: i18n.t('models.snsCategory.modelName') }) }, { root: true })
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
  }
}
